import type { DriftApi } from '@env0/drift-service/api';
import type { ErrorSurfacingOptions, HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type {
  GetDriftCauseGroupsQueryParams,
  GetDriftCauseGroupsResponse,
  GetDriftFixStatsQueryParams,
  GetIgnoredDriftCauseGroupsQueryParams,
  GetIgnoredDriftCauseGroupsResponse,
  IgnoreDriftCauseBody,
  IgnoreDriftCauseResponse,
  UnIgnoreDriftCauseResponse
} from 'types/drift.types';

export default (client: HttpClient) => ({
  getDriftCauseGroups: (
    { projectIds, ...params }: GetDriftCauseGroupsQueryParams,
    { hideNotification, hidePayGateModal }: ErrorSurfacingOptions = {}
  ) =>
    client
      .get<GetDriftCauseGroupsResponse>('drift-causes', {
        params: { ...params, projectIds: projectIds?.length ? projectIds.join(',') : undefined },
        hideNotification,
        hidePayGateModal
      })
      .then(returnData),

  getIgnoredDriftCauseGroups: (
    { projectIds, ...params }: GetIgnoredDriftCauseGroupsQueryParams,
    { hideNotification, hidePayGateModal }: ErrorSurfacingOptions = {}
  ) =>
    client
      .get<GetIgnoredDriftCauseGroupsResponse>('drift-causes/ignored', {
        params: { ...params, projectIds: projectIds?.length ? projectIds.join(',') : undefined },
        hideNotification,
        hidePayGateModal
      })
      .then(returnData),

  ignoreDriftCause: (
    causeId: string,
    body: IgnoreDriftCauseBody,
    { hideNotification, hidePayGateModal }: ErrorSurfacingOptions = {}
  ) =>
    client
      .post<IgnoreDriftCauseResponse>(`drift-causes/${encodeURIComponent(causeId)}/ignore`, body, {
        hideNotification,
        hidePayGateModal
      })
      .then(returnData),

  unIgnoreDriftCause: (
    causeId: string,
    body: IgnoreDriftCauseBody,
    { hideNotification, hidePayGateModal }: ErrorSurfacingOptions = {}
  ) =>
    client
      .post<UnIgnoreDriftCauseResponse>(`drift-causes/${encodeURIComponent(causeId)}/un-ignore`, body, {
        hideNotification,
        hidePayGateModal
      })
      .then(returnData),

  getDriftFixStats: ({ projectIds, ...params }: GetDriftFixStatsQueryParams) =>
    client
      .get<DriftApi.GetDriftFixStats.Response>('drift-causes/fix-stats', {
        params: { ...params, projectIds: projectIds?.length ? projectIds.join(',') : undefined },
        // the endpoint may not be deployed yet, and a project-scoped role can 403 it - the cube hides itself
        // either way, so a toast would be noise
        hideNotification: true,
        // this route carries the same payGate as GET /drift-causes, and the cube still mounts while the page
        // is loading - without this the 402 pops the global upgrade modal on top of the in-page pay-gate state
        hidePayGateModal: true
      })
      .then(returnData)
});
